/* eslint-disable no-unused-vars */
import axios, { AxiosResponse, AxiosError } from 'axios';
import CustomHeaders from '../constants/customHeaders';
import { getCurrentProductId } from './globalUtil';
import { clearAuthToken, getAuthToken } from './local-storage';

const client = axios.create({
  // TODO : Add any hardcoded default baseURL as OR for below line similar to findaya-web
  baseURL: window.location.origin || process.env.REACT_APP_API_BASE_URL,
  timeout: Number(process.env.REACT_APP_API_TIMEOUT_MS),
});

client.interceptors.request.use((req) => {
  req.headers = req.headers || {};

  const authToken = getAuthToken();
  if (authToken) {
    req.headers[CustomHeaders.AUTHORIZATION] = `Bearer ${authToken}`;
  }

  const productId = getCurrentProductId();
  if (productId) {
    req.headers[CustomHeaders.PRODUCT_ID] = productId;
  }

  return req;
});

client.interceptors.response.use(
  (res: AxiosResponse) => res.data as unknown,
  (err: AxiosError) => {
    const { response } = err || {};

    if (response) {
      const { status } = response || {};
      if (status === 401) {
        clearAuthToken();
        if (typeof window !== 'undefined') {
          window.location.href = '/';
          return;
        }
      }
    }

    throw err;
  },
);

export const APIStatus = {
  initial: 'initial',
  loading: 'loading',
  succeeded: 'succeeded',
  failed: 'failed',
};

export default client;
